import stDrive from './drive.component';
import stDriveButton from './driveButton.component';

export default angular
  .module('st.Integrations.Drive', ['st.Core', 'angular-cache'])
  .component('stDrive', stDrive)
  .component('stDriveButton', stDriveButton)
  .service('driveService', ($http, dataService, DRIVE) => ({
    authenticate: (params) =>
      dataService.apiRequest(null, null, true, null, $http.post, DRIVE.API.AUTHENTICATE, {
        params
      }),
    createFolder: (params) =>
      dataService.apiRequest(null, null, true, null, $http.post, DRIVE.API.CREATE_FOLDER, {
        params
      }),
    deauthenticate: (params) =>
      dataService.apiRequest(null, null, true, null, $http.post, DRIVE.API.DEAUTHENTICATE, {
        params
      }),
    deleteFolderOrFile: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.delete,
        DRIVE.API.DELETE_FOLDER_OR_FILE,
        {
          params
        }
      ),
    listFiles: (params) =>
      dataService.apiRequest(null, null, true, null, $http.get, DRIVE.API.LIST_FILES, {
        params
      }),
    uploadFiles: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        DRIVE.API.UPLOAD_FILES,
        {
          params
        },
        null,
        true
      )
  }))
  .constant('DRIVE', {
    API: {
      AUTHENTICATE: '/api/v1/integrations/drive/authenticate/',
      CREATE_FOLDER: '/api/v1/integrations/drive/create-folder/',
      DEAUTHENTICATE: '/api/v1/integrations/drive/deauthenticate/',
      DELETE_FOLDER_OR_FILE: '/api/v1/integrations/drive/delete-folder-or-file/',
      LIST_FILES: '/api/v1/integrations/drive/list-files/',
      UPLOAD_FILES: '/api/v1/integrations/drive/upload-files/'
    }
  });
